import { memo, useRef, useCallback } from 'react';

import { useQuery } from 'react-query';
import { CourseRecommendation, JobQualificationRecommendation } from 'services/core';

import useWindowSize from 'hooks/use-windowSize';
import { useInView } from 'react-intersection-observer';

import ContentRecommendationCard from '../contentrecommendationcard/ContentRecommendationCard';
import ActionButton from '@core/components/actionbutton/ActionButton';
import LinkButton from '@core/components/linkbutton/LinkButton';
import Spinner from '@core/components/spinner/Spinner';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';

import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.scss';

import ArrowRightIcon from 'assets/icons/arrow-right-gray.svg';
import ArrowLeftIcon from 'assets/icons/arrow-left-gray.svg';

import classes from './ContentRecommendation.module.scss';

const ContentRecommendation = ({ content_type = 'course', contentId }) => {
	const { ref, inView } = useInView({
		threshold: 0
	});
	const { mobileDevice, tabletDevice } = useWindowSize();
	const sliderRef = useRef(null);

	const handlePrev = useCallback(() => {
		if (!sliderRef.current) return;
		sliderRef.current.swiper.slidePrev();
	}, []);

	const handleNext = useCallback(() => {
		if (!sliderRef.current) return;
		sliderRef.current.swiper.slideNext();
	}, []);

	const { data, isLoading } = useQuery(
		['recommendation', contentId, content_type],
		() =>
			content_type === 'course'
				? CourseRecommendation.GET(contentId)
				: JobQualificationRecommendation.GET(contentId),
		{
			enabled: !!contentId && !!inView,
			cacheTime: 20 * 60 * 1000,
			staleTime: 20 * 60 * 1000
		}
	);

	return (
		<div className="d-flex flex-column gap-4" ref={ref}>
			{data && !isLoading ? (
				<>
					<div
						className={`${classes['content-recommendation-title']} d-flex flex-row justify-content-between`}>
						<h3>People also viewed</h3>
						<div className="d-flex flex-row gap-2">
							<div>
								<ActionButton kind="blank" onClick={handlePrev}>
									<ArrowLeftIcon />
								</ActionButton>
								<ActionButton kind="blank" onClick={handleNext}>
									<ArrowRightIcon />
								</ActionButton>
							</div>
							{/* <LinkButton to="#" kind="simple">
								View All
							</LinkButton> */}
						</div>
					</div>
					<div>
						<Swiper
							ref={sliderRef}
							slidesPerView={mobileDevice ? 1.1 : tabletDevice ? 2.1 : 3.1}
							spaceBetween={30}
							// pagination={{
							// 	clickable: true
							// }}
							modules={[Pagination]}
							className="mySwiper">
							{data?.data?.map((card) => (
								<SwiperSlide style={{ height: 'auto' }} key={card.id + card.type}>
									<ContentRecommendationCard content={card} />
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</>
			) : (
				<div className="d-flex align-items-center justify-content-center w-100 py-5">
					<Spinner />
				</div>
			)}
		</div>
	);
};

export default memo(ContentRecommendation);
